

















import {Component, Prop, Vue} from 'vue-property-decorator'
import {Theme} from "@/store";

@Component
export default class CardCommon extends Vue {

  @Prop() readonly title?: string
  @Prop() readonly description?: string
  @Prop() readonly theme?: Theme
  @Prop() readonly contentClass?: string

}
